module.exports = __webpack_public_path__ + "img/chr_ts_3_penlight.91eba881.png";